import bus from './bus'

export default function(Vue: any) {
	if (Vue.prototype.$audioPlayer) {
		return
	}

	const api: any = {
		play: function(recordObj: any) {
			bus.$emit('play', recordObj)
		},
		close: function() {
			bus.$emit('close')
		},
		addClearListener: function(cb: Function) {
			bus.$on('clear', cb)
		},
		removeClearListener: function() {
			bus.$off('clear')
		},
	}
	api.instance = bus

	Vue.prototype.$audioPlayer = api
}
